import { Link } from "react-router-dom";
import { ArrowRight, Gem } from "lucide-react";
import { useAdRotation, AdLink, AdMedia } from "@/components/AdSlot";
import { homeTrack } from "../shared";

const Kicker = () => (
  <p className="flex items-center gap-1.5 font-mono text-[9.5px] font-bold uppercase tracking-[0.2em] text-[#A78BFA]">
    <Gem className="h-3 w-3" aria-hidden /> Premium Insight
  </p>
);

const SponsorState = ({ ad }: { ad: any }) => (
  <AdLink ad={ad} testid="premium-insight-sponsor-link"
    className="group relative flex flex-col flex-1 min-h-[280px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#22D3EE]/60">
    <AdMedia ad={ad} className="absolute inset-0 w-full h-full object-cover motion-safe:transition-transform motion-safe:duration-500 group-hover:scale-[1.015]" />
    <span aria-hidden className="absolute inset-x-0 top-0 h-16 bg-gradient-to-b from-black/55 to-transparent" />
    <div className="relative flex items-center justify-between gap-3 px-5 pt-4">
      <Kicker />
      <span className="inline-flex items-center rounded-md border border-[#F59E0B]/70 bg-[#030407]/90 px-2 py-0.5 font-mono text-[9px] font-medium text-[#FBBF24]"
        data-testid="premium-insight-sponsored-label">
        SPONSORED
      </span>
    </div>
    <span className="absolute bottom-3 right-4 font-mono text-[9px] text-gray-300 uppercase tracking-widest border border-white/25 bg-black/55 rounded px-1.5 py-0.5"
      data-testid="premium-insight-ad-chip">Ad</span>
  </AdLink>
);

const HouseState = () => (
  <div className="relative flex flex-col flex-1 min-h-[300px]" data-testid="premium-insight-house">
    <img src="/thumbs/premium_insight_globe.jpg" alt="" aria-hidden loading="lazy"
      className="absolute inset-0 w-full h-full object-cover object-right" />
    <span aria-hidden className="absolute inset-0 bg-gradient-to-r from-black via-black/75 to-black/10" />
    <div className="relative px-5 pt-4">
      <Kicker />
    </div>
    <div className="relative p-5 mt-auto max-w-[360px]">
      <h3 className="font-heading font-black text-white text-[20px] sm:text-[21px] leading-[1.18]">
        Onchain intelligence built for the next era of capital markets.
      </h3>
      <p className="text-[12.5px] text-gray-400 mt-2">Real-time data. Smarter decisions.</p>
      <Link to="/premium" onClick={() => homeTrack("premium_insight", "house_cta")} data-testid="premium-insight-cta"
        className="sparkle-btn group/cta mt-4 inline-flex items-center gap-2 rounded-lg px-4 py-2 text-[12.5px] font-bold text-white bg-gradient-to-r from-[#00A6E0] via-[#3B6CF6] to-[#7C3AED] shadow-[0_4px_24px_rgba(59,108,246,0.3)] hover:brightness-110 hover:shadow-[0_6px_30px_rgba(124,58,237,0.4)] motion-safe:transition-[filter,box-shadow] motion-safe:duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/70">
        Explore NewsLayer Premium
        <ArrowRight className="h-3.5 w-3.5 motion-safe:transition-transform motion-safe:duration-200 group-hover/cta:translate-x-[3px]" aria-hidden />
      </Link>
      <p className="font-heading font-bold tracking-[0.34em] text-[10px] text-gray-400 mt-5">
        NEWSLAYER <span className="text-[#A78BFA]">PREMIUM</span>
      </p>
    </div>
  </div>
);

/* Lower-right module — active premium_insight campaign, else the NewsLayer house creative. */
export const PremiumInsightCard = () => {
  const { ad, hidden } = useAdRotation("premium_insight");
  const sponsor = !hidden && !!ad;
  return (
    <div data-testid="premium-insight-card"
      className="premium-aurora-frame relative min-w-0 rounded-xl bg-black overflow-hidden flex flex-col lg:flex-1 shadow-[0_0_60px_-24px_rgba(59,108,246,0.45)]">
      {sponsor ? <SponsorState ad={ad} /> : <HouseState />}
    </div>
  );
};
